import React, { Component } from 'react';
import { Row, Col, Statistic } from 'antd';
import SousMenu from '../principal/SousMenu';
import { Link } from 'react-router-dom';



export default class GraphiqueFinTemps extends Component {
    constructor(props) {
        super(props);
        this.duree = Math.round(props.duree / 1000);
        this.perdu = props.perdu;
        this.type = props.type;
        this.state = {
            classement: 0,
            meilleurTemps: 0,
            tempsMoyen: 0,
            nbJoueurs: 0,
        }
    }


    componentDidMount() {

            let url = new URL(process.env.REACT_APP_URL_FINTEMPS);
            var data = new FormData();
            data.append('idTest', this.props.idTest);
            data.append('type', this.type);
            data.append('duree', this.duree);
            data.append('perdu', this.perdu);
            fetch(url, {
                method: "POST",
                body: data
            }).then(res => res.json())
                .then(res => {
                    this.setState({
                        classement: res.classement,
                        meilleurTemps: res.meilleurTemps,
                        tempsMoyen: res.tempsMoyen,
                        nbJoueurs: res.nbJoueurs
                    });
                });

        
    }
    messageFelicitation() {
        if (this.state.classement === 1) {
            return <p><b>Fantastique ! Vous êtes le meilleur ! </b></p>;
        }
        if (this.state.classement <= 3) {
            return <p><b>Excellent ! Vous êtes parmi les trois meilleurs ! </b></p>;
        }
        if ((this.state.classement <= 10)) {
            return <p><b>Bien ! Vous êtes dans les 10 premiers ! </b></p>;
        }
        if ((this.state.classement <= 50)) {
            return <p><b> Bravo ! Vous êtes dans les 50 premiers ! </b></p>;
        }

    }


    render() {
        return (<div>
            <Row type="flex" justify="center"><Col xs={{ span: 20 }} md={{ span: 12 }} lg={{ span: 8 }} className="centre"><div>
                {!this.perdu ? <div className="espaceHaut30"><h1>Votre temps de jeu : <span className="lettreRouge">{`${this.duree/60|0}:${this.duree%60}`}</span></h1>
                <Statistic title="Classement :" value={this.state.classement} suffix={'/ ' + this.state.nbJoueurs} />
                {this.messageFelicitation()}</div> : <p className="centre espaceHaut30">Vous avez perdu</p>}
                <p>Le meilleur temps est : <b>{`${this.state.meilleurTemps/60|0}:${this.state.meilleurTemps%60}`}</b></p>
                <p>Le temps moyen est : <b>{`${this.state.tempsMoyen/60|0}:${this.state.tempsMoyen%60}`}</b></p>
                <p>Vous aimez les jeux de lettres comme <b className="couleurTitre">les mots codés, le boogle, les mots coupés</b> ? Venez essayer notre <a href="https://concours.evalquiz.com">challenge de lettres et de mots en 64 étapes</a>.</p>
                <SousMenu titre="Jeux de la même catégorie" supprimer={this.props.idTest} type={this.type}></SousMenu></div>
                <Link className="jeuSuivant" to={"/Jeu/"}>Les autres jeux</Link></Col></Row>



        </div>);
    }
}